import { action, computed, observable } from 'mobx';

import { query, serviceQueries } from '@estee/elc-service-bus';

import { Config } from '~domain/entities/Config';
import {
    brandIdPath,
    IAppAndBUIDConfigs,
    IAppConfigWithRequestedBUIDKeys,
    IServiceAppConfigs
} from '~domain/entities/IConfig';

export class ConfigRepository {
    @observable private readonly serviceConfig: Config;
    loyaltyConfig: unknown;

    constructor(serviceConfig: Config) {
        this.serviceConfig = serviceConfig;
    }

    private modifyBuidPathedConfigs = (buidConfig: IAppAndBUIDConfigs['buidConfig']) => {
        const { [brandIdPath]: id, ...remainingConfigs } = buidConfig;

        return { ...remainingConfigs, brand: { id } } as IServiceAppConfigs;
    };

    @action public fetchConfigs = async ({
        appConfig,
        requestedBuidConfigs
    }: IAppConfigWithRequestedBUIDKeys) => {
        const buidConfigResponse = await query(serviceQueries.GET_CONFIG, requestedBuidConfigs);
        const buidConfig = this.modifyBuidPathedConfigs(buidConfigResponse);

        this.serviceConfig.updateConfig({
            appConfig,
            buidConfig
        });
    };

    @computed
    public get config(): Config {
        return this.serviceConfig;
    }
}
